import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export const DashboardCard = ({ name, value, icon, link, color }) => {
  return (
    <div className="col-lg-3 col-6">
      <div className="small-box" style={{ backgroundColor: color }}>
        <div className="inner">
          <h3 className="text-white">{name}</h3>
          <p className="text-white font-weight-bold">{value}</p>
        </div>
        <div className="icon  mb-4">
          <i className={icon} />
        </div>
        <Link to={link} className="small-box-footer">
          More info <i className="fas fa-arrow-circle-right" />
        </Link>
      </div>
    </div>
  );
};

DashboardCard.propTypes = {
  name: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};
